import axios from 'axios';

class ProductService {
    // Servicios existentes para productos (asumiendo que existen)
    static async getProducts(filters = {}) {
        return axios.get(process.env.REACT_APP_API_PRODUCTS_ROUTE, {
            params: filters,
            withCredentials: true
        });
    }

    static async getProductsPage(page = 0, size = 10, sortBy = 'id', sortDirection = 'ASC', filters = {}) {
        return axios.get(process.env.REACT_APP_API_PRODUCTS_PAGE_ROUTE, {
            params: {
                page,
                size,
                sortBy,
                sortDirection,
                ...filters
            },
            withCredentials: true
        });
    }

    static async getProductById(id) {
        return axios.get(`${process.env.REACT_APP_API_PRODUCTS_ROUTE}/${id}`, {
            withCredentials: true
        });
    }

    static async createProduct(product) {
        return axios.post(process.env.REACT_APP_API_PRODUCTS_ROUTE, product, {
            withCredentials: true
        });
    }

    static async updateProduct(id, product) {
        return axios.put(`${process.env.REACT_APP_API_PRODUCTS_ROUTE}/${id}`, product, {
            withCredentials: true
        });
    }

    static async deleteProduct(id) {
        return axios.delete(`${process.env.REACT_APP_API_PRODUCTS_ROUTE}/${id}`, {
            withCredentials: true
        });
    }

    // NUEVOS SERVICIOS PARA CONFIGURACIÓN DE GUSTOS
    
    /**
     * Crear configuración de gustos para un producto
     * @param {number} productId - ID del producto
     * @param {number} maxFlavors - Máximo número de gustos permitidos
     * @returns {Promise} Response con mensaje de éxito
     */
    static async createProductConfiguration(productId, maxFlavors) {
        return axios.post(
            `${process.env.REACT_APP_API_PRODUCTS_ROUTE}/${productId}/configuration?maxFlavors=${maxFlavors}`,
            {},
            {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    /**
     * Actualizar configuración existente de gustos
     * @param {number} productId - ID del producto
     * @param {number} maxFlavors - Máximo número de gustos permitidos
     * @returns {Promise} Response con mensaje de éxito
     */
    static async updateProductConfiguration(productId, maxFlavors) {
        return axios.put(
            `${process.env.REACT_APP_API_PRODUCTS_ROUTE}/${productId}/configuration?maxFlavors=${maxFlavors}`,
            {},
            {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    /**
     * Eliminar configuración de gustos de un producto
     * @param {number} productId - ID del producto
     * @returns {Promise} Response con mensaje de éxito
     */
    static async deleteProductConfiguration(productId) {
        return axios.delete(
            `${process.env.REACT_APP_API_PRODUCTS_ROUTE}/${productId}/configuration`,
            {
                withCredentials: true
            }
        );
    }

    /**
     * Validar configuración de producto
     * @param {Object} product - Objeto producto
     * @throws {Error} Si la configuración es inválida
     */
    static validateProductConfiguration(product) {
        if (product.hasFlavorConfiguration) {
            if (!product.maxFlavors || product.maxFlavors < 1) {
                throw new Error('Debe especificar al menos 1 gusto máximo');
            }
            if (product.maxFlavors > 10) {
                throw new Error('Máximo 10 gustos permitidos');
            }
        }
    }

    /**
     * Procesar producto con configuración (para crear/actualizar)
     * @param {Object} product - Producto a procesar
     * @returns {Promise} Producto procesado
     */
    static async processProductWithConfiguration(product) {
        try {
            // Validar configuración
            this.validateProductConfiguration(product);

            // Crear/actualizar producto primero
            let productResponse;
            if (product.id) {
                productResponse = await this.updateProduct(product.id, product);
            } else {
                productResponse = await this.createProduct(product);
            }

            const savedProduct = productResponse.data;
            const productId = product.id || savedProduct.id; // Usar el ID original o el del producto guardado

            // Manejar configuración de gustos
            console.log('Procesando configuración - productId:', productId);
            console.log('Procesando configuración - hasFlavorConfiguration:', product.hasFlavorConfiguration);
            console.log('Procesando configuración - maxFlavors:', product.maxFlavors);
            console.log('Procesando configuración - productConfiguration:', product.productConfiguration);
            
            if (product.hasFlavorConfiguration && product.maxFlavors) {
                try {
                    // Intentar actualizar primero, si falla crear nueva
                    try {
                        await this.updateProductConfiguration(productId, product.maxFlavors);
                        console.log('Configuración actualizada exitosamente');
                    } catch (updateError) {
                        console.log('No se pudo actualizar, intentando crear nueva configuración');
                        await this.createProductConfiguration(productId, product.maxFlavors);
                        console.log('Nueva configuración creada exitosamente');
                    }
                } catch (configError) {
                    console.warn('Error al procesar configuración:', configError);
                    // No falla el proceso completo si hay error en configuración
                }
            } else if (!product.hasFlavorConfiguration && product.id) {
                // Eliminar configuración si se desmarcó la opción (solo para productos existentes)
                try {
                    await this.deleteProductConfiguration(productId);
                    console.log('Configuración eliminada exitosamente');
                } catch (deleteError) {
                    console.log('No había configuración que eliminar o error al eliminar:', deleteError.message);
                    // Es normal que falle si no había configuración
                }
            }

            return productResponse;
        } catch (error) {
            throw error;
        }
    }
}

export default ProductService;